/**
 * All UI text in Turkish
 * Professional clinical tone for standalone web app
 */
export const Strings = {
  appName: 'Kalp Damar Sağlığı Risk Analiz Paneli',
  disclaimer:
    'Bu panel, kardiyovasküler risk değerlendirmesi için SCORE2, BMI ve FindRisk algoritmalarını kullanır.',
  /** Professional legal disclaimer - not medical advice. */
  medicalDisclaimer:
    'Bu araç tanı veya tedavi amacı taşımaz. Tıbbi kararlar için mutlaka bir sağlık uzmanına başvurunuz.',
  clinicalInsightPrefix: 'Klinik Öngörü:',
  clinicalResultFooter:
    'Sonuçlar bilimsel algoritmalara dayalı klinik risk tahminleridir.',

  welcomeTitle: 'Kalp Damar Sağlığı Risk Analiz Paneli',
  heroSubheadline:
    'Bilimsel algoritmalarla sağlığınızı takip edin.',
  offlineNote: 'Tamamen Çevrimdışı (Offline) Çalışır',
  offlineNoteFull: 'Bu uygulama internet olmadan kullanılabilir.',
  iAmHealthcare: 'Sağlık Çalışanıyım',
  iAmNotHealthcare: 'Sağlık Çalışanı Değilim',
  modeBInstruction: 'Bilmediğiniz terimler için (?) ikonuna tıklayın.',

  score2Tab: 'SCORE2 (<70 Yaş)',
  score2OpTab: 'SCORE2-OP (≥70 Yaş)',
  calculate: 'Hesapla',
  calculatorWarningRange:
    'Bazı değerler uyarı aralığında. Hesaplama yapılabilir ancak değerleri kontrol etmeniz önerilir.',
  gender: 'Cinsiyet',
  male: 'Erkek',
  female: 'Kadın',
  age: 'Yaş',
  tobacco: 'Sigara / Tütün',
  diabetes: 'Diyabet',
  yes: 'Evet',
  no: 'Hayır',
  systolicBp: 'Sistolik Kan Basıncı (SKB) - mmHg',
  totalCholesterol: 'Toplam Kolesterol (mg/dL)',
  hdlCholesterol: 'HDL Kolesterol (mg/dL)',

  resultTitle: '10 Yıllık Kardiyovasküler Risk Düzeyi',
  riskPercentage: 'Risk: %{value}',
  riskCategory: 'Kategori',
  riskLow: 'Düşük',
  riskModerate: 'Orta',
  riskHigh: 'Yüksek',
  riskVeryHigh: 'Çok Yüksek',

  infoTobacco:
    'Son 5 yılda sigara veya tütün ürünü kullandınız mı? (Günlük kullanım veya bırakmış olsanız bile 5 yıl içinde kullanım sayılır.)',
  infoDiabetes:
    'Tip 1 veya Tip 2 diyabet tanısı almış mısınız? (Kan şekeri yüksekliği ile seyreden kronik hastalık.)',
  infoSystolicBp:
    'Sistolik kan basıncı (büyük tansiyon), kalp atımı sırasında damarlardaki en yüksek basınçtır. Örn: 120/80 ifadesinde 120 sistolik değerdir. Son ölçümünüzü girin (mmHg).',
  infoTotalCholesterol:
    'Toplam kolesterol, kanınızdaki tüm kolesterol türlerinin toplamıdır. Son kan tahlilinizdeki "Total Kolesterol" veya "Kolesterol" değerini girin (mg/dL).',
  infoHdlCholesterol:
    'HDL kolesterol "iyi kolesterol" olarak bilinir. Kan tahlilinizde "HDL" veya "HDL-Kolesterol" değerini girin (mg/dL).',

  // Selection screen
  selectionTitle: 'Risk Düzeyi Hesaplama',
  riskButton: 'SCORE2 - Kardiyovasküler Risk',
  bmiButton: 'BMI - Vücut Kitle İndeksi',
  bmiInfoTooltip:
    'BMI (Vücut Kitle İndeksi), kilonuzun boyunuza oranını belirleyen bilimsel bir ölçüttür.',
  bmiInfoTitle: 'BMI Nedir?',
  bmiInfoBody:
    'Vücut Kitle İndeksi (BMI), kilonuzun boyunuza oranını hesaplayarak vücut ağırlığınızın sağlıklı aralıkta olup olmadığını değerlendiren bilimsel bir ölçüttür.',
  findRiskInfoTitle: 'FindRisk Nedir?',
  findRiskInfoBody:
    'FindRisk, önümüzdeki 10 yıl içinde Tip 2 Diyabet geliştirme riskinizi 8 basit soruyla belirleyen, dünya çapında kabul görmüş bir risk değerlendirme testidir.',
  close: 'Kapat',

  // BMI
  bmiTitle: 'BMI Hesaplama',
  bmiHeightLabel: 'Boy (cm)',
  bmiHeightHint: 'Santimetre cinsinden boyunuzu girin (örn: 175)',
  bmiWeightLabel: 'Kilo (kg)',
  bmiWeightHint: 'Kilogram cinsinden kilonuzu girin (örn: 70)',
  bmiCalculate: 'Hesapla',
  bmiYourResult: 'BMI Sonucunuz',
  bmiCategory: 'Kategori',
  bmiUnderweight: 'Zayıf',
  bmiNormal: 'Normal Kilolu',
  bmiOverweight: 'Fazla Kilolu',
  bmiObese1: 'Obez (Sınıf I - Hafif)',
  bmiObese2: 'Obez (Sınıf II - Orta)',
  bmiObese3: 'Obez (Sınıf III - Morbid)',
  bmiNewCalculation: 'Yeni Hesaplama',

  // FindRisk
  findRiskButton: 'FindRisk - Diyabet Risk Değerlendirmesi',
  findRiskTitle: 'FindRisk - Diyabet Risk Değerlendirmesi',
  findRiskAgeLabel: 'Yaş',
  findRiskBmiLabel: 'BMI (Vücut Kitle İndeksi)',
  findRiskBmiHint: 'Bilmiyorsanız önce BMI Hesaplama bölümünden hesaplayabilirsiniz.',
  findRiskWaistLabel: 'Bel Çevresi (cm)',
  findRiskWaistHint: 'Göbek deliği hizasında ölçün.',
  findRiskWaistMale: 'Erkek',
  findRiskWaistFemale: 'Kadın',
  findRiskActivityLabel: 'Günde en az 30 dakika fiziksel aktivite yapıyor musunuz?',
  findRiskVegetablesLabel: 'Her gün sebze veya meyve tüketiyor musunuz?',
  findRiskBpMedsLabel: 'Düzenli olarak tansiyon ilacı kullanıyor musunuz?',
  findRiskHighGlucoseLabel: 'Daha önce kan şekeriniz yüksek çıktı mı? (Muayene, hastalık, hamilelik vb.)',
  findRiskFamilyLabel: 'Ailenizde diyabet (Tip 1 veya Tip 2) tanısı almış biri var mı?',
  findRiskFamilyNone: 'Hayır',
  findRiskFamilySecondary: 'Evet (Dede, nene, amca, hala, teyze, dayı veya kuzen)',
  findRiskFamilyPrimary: 'Evet (Anne, baba, kardeş veya çocuk)',
  findRiskYourResult: 'Diyabet Risk Sonucunuz',
  findRiskScore: 'Skor',
  findRiskLow: 'Düşük Risk (1/100)',
  findRiskMild: 'Hafif Risk (1/25)',
  findRiskModerate: 'Orta Derece Risk (1/6)',
  findRiskHigh: 'Yüksek Risk (1/3)',
  findRiskVeryHigh: 'Çok Yüksek Risk (1/2)',
  findRiskNewCalculation: 'Yeni Hesaplama',
  findRiskRecLow:
    'Tebrikler! Sağlıklı yaşam tarzınızı koruyun. Dengeli beslenmeye ve düzenli fiziksel aktiviteye (haftada en az 150 dk) devam edin.',
  findRiskRecMild:
    'Beslenme alışkanlıklarınıza dikkat edin. Lifli gıdaları artırın ve kilonuzu ideal sınırda tutmaya çalışın.',
  findRiskRecModerate:
    'Diyabet riskiyle ilgili bir sağlık uzmanına danışmanız faydalı olabilir. Bel çevresini kontrol altına almak için fiziksel aktiviteyi artırmayı düşünün.',
  findRiskRecHigh:
    'Bir hekime başvurarak kan şekeri ölçümü yaptırmanız önerilir. Beslenme uzmanı desteğiyle kilo yönetimi ve aktif yaşam planı oluşturun.',
  newCalculation: 'Yeni Hesaplama',

  // User agreement (first launch)
  userAgreementTitle: 'Kullanım Koşulları',
  userAgreementText:
    'Bu panel tıbbi bir cihaz değildir. Sunulan veriler SCORE2, BMI ve FindRisk algoritmalarına dayalı bilgilendirme amaçlıdır. Tanı veya tedavi kararları için mutlaka bir sağlık uzmanına başvurunuz.',
  userAgreementButton: 'Kabul Ediyorum',

  // Algorithm info modal
  algorithmModalTitle: 'Kullanılan Yöntemler Hakkında',
  algorithmModalScore2Heading: 'SCORE2 (40-69 Yaş)',
  algorithmModalScore2Text:
    'Avrupa Kardiyoloji Derneği (ESC) tarafından geliştirilen, 40-69 yaş aralığındaki bireylerin önümüzdeki 10 yıl içinde ölümcül veya ölümcül olmayan bir kalp-damar hastalığı geçirme riskini hesaplayan güncel algoritmadır.',
  algorithmModalScore2OpHeading: 'SCORE2-OP (70+ Yaş)',
  algorithmModalScore2OpText:
    "70 yaş ve üzeri bireyler için özel olarak kalibre edilmiş versiyondur (OP: Older Persons). İleri yaş grubundaki metabolik farklılıkları dikkate alarak daha hassas bir risk tahmini sunar.",
  algorithmModalBmiHeading: 'BMI (Vücut Kitle İndeksi)',
  algorithmModalBmiText:
    "Dünya Sağlık Örgütü (WHO) tarafından kabul edilen, bireyin kilosunun boyuna oranını baz alarak ağırlık durumunu (zayıf, normal, kilolu, obez) sınıflandıran temel sağlık göstergesidir.",
  algorithmModalFindRiskHeading: 'FindRisk (Tip 2 Diyabet Risk Testi)',
  algorithmModalFindRiskText:
    'Finlandiya Diyabet Derneği tarafından geliştirilen, 8 parametre üzerinden bireyin önümüzdeki 10 yıl içinde Tip 2 Diyabet geliştirme riskini öngören, uluslararası geçerliliğe sahip bir anket yöntemidir.',
  algorithmModalFooterNote:
    "Bu panel, Türkiye'nin de içinde bulunduğu 'Yüksek Riskli Bölge' katsayılarını kullanır.",

  // Legal / About modal
  legalModalTitle: 'Hakkında ve Yasal Uyarı',
  legalModalDisclaimerHeading: 'Yasal Uyarı',
  legalModalDisclaimerText:
    'Bu panel tıbbi bir cihaz değildir ve kesin teşhis koymaz. Sunulan veriler ESC SCORE2, WHO BMI standartları ve FindRisk parametrelerine dayalı bilgilendirme amaçlıdır. Uygulamanın kullanımından doğabilecek kararlardan kullanıcı sorumludur; tanı veya tedavi için mutlaka bir hekime başvurulmalıdır.',
  legalModalPrivacyHeading: 'Veri Gizliliği',
  legalModalPrivacyText:
    'Gizliliğiniz önceliğimizdir. Girdiğiniz hiçbir sağlık verisi kaydedilmez, sunuculara gönderilmez veya üçüncü taraflarla paylaşılmaz. Tüm hesaplamalar anlık olarak cihazınızda gerçekleşir.',
  legalModalContactHeading: 'İletişim ve Destek',
  legalModalContactText: 'Sorularınız ve geri bildirimleriniz için:',
  legalModalContactEmail: 'destek@yelken.pro',
  legalModalReferencesHeading: 'Kaynakça',
  legalModalReferencesText:
    'ESC SCORE2/SCORE2-OP yönergeleri, WHO BMI sınıflamaları ve FindRisk kriterleri temel alınmıştır.',
  legalModalVersion: 'v1.0.0',
} as const;
